import React, {useState, useEffect} from 'react';
import { Linking, View, TouchableOpacity } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Modal from '../../../../components/Modal';


export default function DocumentDetailModal({ onRequestClose, document }) {
  console.log(document)
  return (
    <Modal onRequestClose={onRequestClose} style={{modal: tw`w-90%`}}>
      <View style={tw`px-2`}>
        <Text style={tw`text-gray-600 leading-1.2 text-lg mb-4 text-center`}>{document.name}</Text>
        <Text style={tw`text-gray-500`}>{document.text}</Text>

        <View style={tw``}>
          {
            document.files?.map(file =>
              <TouchableOpacity
                key={file.uuid}
                style={tw`row justify-between bg-white rounded-lg px-3 py-3 mb-2 border border-gray-200`}
                onPress={() => Linking.openURL(file.url)}
                // onPress={() => setSelectedDocumentModal(doc)}
              >
                {/* <Text style={tw`text-gray-400 flex-1`}>{JSON.stringify(file)}</Text> */}
                <Text style={tw`text-gray-400 flex-1`}>{file.name}</Text>

                {/* <Icon name='chevron-right' style={tw`text-gray-700 ml-2`} /> */}
              </TouchableOpacity>
            )
          }
        </View>
      </View>
    </Modal>
  );
}
